import React from 'react';
import en from '../../lang/en-us';
import { CheckBoxField } from '../../lib/CheckBoxField';
import { SubmitButton } from '../../lib/Button';
import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { GetDevicePayload, ResetDevicePayload } from '../../redux-store/types/mobile';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { getDevices, onResetDevices } from '../../redux-store/actions/mobile';
import { RootStateType } from '../../redux-store/reducers';
import { AuthState } from '../../redux-store/types/login';
import { getPlatformWisePayload } from '../../redux-store/middleware';
import { useState } from 'react';
import { OTP_ACTIONS } from '../../utils/constants';
import { sendPhoneOTP } from '../../redux-store/actions/nct';

const { common } = en;

interface ResetDeviceProps extends AuthState {
    history: History;
    getDevices: (body: GetDevicePayload) => Promise<any>;
}

type Device = {
    deviceMeta: string;
    id: string;
    deviceName: string;
};

function ResetDevices({ ...props }: any) {
    const [devices, setDevices] = useState<Device[]>([]);
    const [selectedDevices, setSelectedDevices] = useState<string[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { METADATA: metaData } = getPlatformWisePayload();

    useEffect(() => {
        async function getRegisteredDevices() {
            setLoading(true);
            try {
                const res = await props.getDevices({
                    pan: props.pan,
                    metaData,
                    mobile: props.mobile,
                    email: props.email || '',
                    pekrn: '',
                });
                const { body = [], error } = res || {};
                setDevices(body);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        getRegisteredDevices();
    }, []);

    const onSelected = (id: string) => (e: any) => {
        setSelectedDevices((devices: string[]) => {
            if (devices.includes(id)) {
                return devices.filter((_id) => id !== _id);
            }
            return [...devices, id];
        });
    };

    const onReset = async () => {
        try {
            setLoading(true);
            const { pan, pekrn, mobile } = props;
            let payload = {
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.RESET_DEVICE,
                email: props.email,
            };
            let res = (await props.sendPhoneOTP(payload)) || {};
            if (res) {
                props.history.replace('reset-device-otp', { selectedDevices, ...res?.body });
            }
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="mobile_mode login-auth set-pin reset-devices">
            <div className="logo">
                <a
                    role="button"
                    tabIndex={0}
                    aria-label="Go back"
                    onClick={() => props.history.goBack()}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.history.goBack();
                        }
                    }}
                >
                    <img
                        src="/images/left-arrow-white.svg"
                        alt=""
                        aria-hidden="true"
                    />
                </a>
                <h3>
                    {common.resetDevices.resetTxt} {common.resetDevices.devicesTxt}
                </h3>
            </div>
            <div className="login-auth-content">
                <img src="/images/set-pin-icon.png" alt="" />
                <h3>
                    {common.resetDevices.resetTxt} <span>{common.resetDevices.devicesTxt}</span>
                </h3>
                <p>Choose the devices to logout</p>
                <div className="reset-devices-list">
                    {devices.map((device) => (
                        <CheckBoxField
                            onChange={onSelected(device.id)}
                            value={selectedDevices.includes(device.id)}
                            label={device.deviceName}
                        />
                    ))}
                    {/* <CheckBoxField label="Device 1" />
                    <CheckBoxField label="Device 2" />
                    <CheckBoxField label="Device 3" />
                    <CheckBoxField label="Device 4" />
                    <CheckBoxField label="Device 5" /> */}
                    <div className="btns">
                        <SubmitButton
                            disabled={!devices.length}
                            onClick={onReset}
                            label={common.resetDevices.resetTxt}
                        />
                    </div>
                </div>
            </div>
            <Dialog maxWidth={'sm'} open={loading} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p>{'Please wait...'}</p>
                </div>
            </Dialog>
        </div>
    );
}
export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    getDevices,
    onResetDevices,
    sendPhoneOTP,
})(ResetDevices);
